import { Icon } from '../Icon';

export interface ServiceArea {
  name: string;
  state: string;
}

export interface VBCLocationsProps {
  serviceAreas: ServiceArea[];
}

/**
 * Service areas / location info with map pin. Server Component.
 */
export function VBCLocations({ serviceAreas }: VBCLocationsProps) {
  if (serviceAreas.length === 0) return null;

  return (
    <section
      className="mb-10 rounded-xl border p-6"
      style={{
        borderColor: 'var(--brand-card-border)',
        boxShadow: 'var(--shadow-resting)',
        backgroundColor: 'var(--brand-card-bg)',
      }}
    >
      <h2
        className="overline mb-4"
        style={{ color: 'var(--brand-primary, #014F8A)' }}
      >
        Service Areas
      </h2>
      <div className="flex flex-wrap gap-2">
        {serviceAreas.map((area, i) => (
          <span
            key={`${area.name}-${i}`}
            className="inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5"
            style={{
              borderColor: 'var(--brand-card-border)',
              color: 'var(--brand-text-muted)',
              fontSize: '13px',
              letterSpacing: '0.01em',
            }}
          >
            <Icon name="location_on" size={12} style={{ color: 'var(--brand-input-placeholder)' }} />
            {area.name}
            {area.state && `, ${area.state}`}
          </span>
        ))}
      </div>
    </section>
  );
}
